import React, { useState, useEffect } from "react";
import api from "../../../api";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
  const AddPackage = ({ onAdd }) => {
  const [packageName, setPackageName] = useState("");
  const [packageType, setPackageType] = useState(""); // Empty by default
  const [amount, setAmount] = useState(0);
  const [transactionFee, setTransactionFee] = useState("");
  const [totalPackageAmount, setTotalPackageAmount] = useState(0);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  // Update total package amount when amount or transaction fee changes
  useEffect(() => {
    const parsedAmount = parseFloat(amount) || 0;
    const fee = parseFloat(transactionFee) || 0;
    setTotalPackageAmount(parsedAmount + fee);
  }, [amount, transactionFee]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const finalPackageType =
      packageType === "Full Access" ||
      packageType === "Monthly Subscription" ||
      packageType === "Chapter-wise Subscription"
        ? packageType
        : "N/A";

    const newPackage = {
      packageName,
      packageType: finalPackageType,
      amount: parseFloat(totalPackageAmount),
      transactionFee: parseFloat(transactionFee),
      totalPackageAmount: parseFloat(totalPackageAmount),
    };

    try {
      await api.post("/admins/packagelist/post", newPackage, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Reset form fields
      setPackageName("");
      setPackageType("");
      setAmount(0);
      setTransactionFee("");
      setTotalPackageAmount(0);
      setError("");
      setSuccess("Package added successfully!");
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError("Error adding package. Please try again.");
      }
      setSuccess("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h2>Add New Package</h2>
      {error && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {error}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setError("")}
          ></button>
        </div>
      )}
      {success && (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {success}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setSuccess("")}
          ></button>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Package Name</label>
          <input
            type="text"
            className="form-control"
            value={packageName}
            onChange={(e) => setPackageName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Package Type</label>
          <select
            className="form-select"
            value={packageType}
            onChange={(e) => setPackageType(e.target.value)}
          >
            <option value="">-- Select Package Type --</option>
            <option value="Full Access">Full Access</option>
            <option value="Monthly Subscription">Monthly Subscription</option>
            <option value="Chapter-wise Subscription">Chapter-wise Subscription</option>
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Package Amount</label>
          <input
            type="number"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Transaction Fee</label>
          <input
            type="number"
            className="form-control"
            value={transactionFee}
            onChange={(e) => setTransactionFee(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Total Package Amount</label>
          <input
            type="number"
            className="form-control"
            value={totalPackageAmount}
            readOnly
          />
        </div>
      
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Adding..." : "Add Package"}
        </button>
      </form>
    </div>
  );
};

export default AddPackage;